import React, { useEffect } from 'react';
import Dashboard from '../../components/dashboard/Dashboard';
import { useMiwiStore, generalStore, playlistStore } from '../../store';

const DashboardView = () => {
    const { setPageName } = generalStore();
    const { playlists } = playlistStore();
    const { overrideMediaUrl } = useMiwiStore();

    useEffect(() => {
        setPageName('Dashboard');
    }, []);

    return (
        <div className="b-dashboard-view">
            <Dashboard
                playlists={playlists as any}
                overrideMediaUrl={overrideMediaUrl}
            />
        </div>
    );
};

export default DashboardView;
